import React, { useEffect } from "react";
import {
  Box,
  Heading,
  Link,
  Image,
  Text,
  Divider,
  HStack,
  Tag,
  Wrap,
  WrapItem,
  SpaceProps,
  useColorModeValue,
  Container,
  VStack,
  Flex,
  Button,
  useColorMode,
} from "@chakra-ui/react";

import Fade from "react-reveal/Fade";
const BlogTags = (props) => {
  return (
    <HStack spacing={2} marginTop={props.marginTop}>
      {props.tags.map((tag) => {
        return (
          <Tag size={"md"} variant="solid" colorScheme="orange" key={tag}>
            {tag}
          </Tag>
        );
      })}
    </HStack>
  );
};

export const BlogAuthor = (props) => {
  return (
    <HStack marginTop="2" spacing="2" display="flex" alignItems="center">
      <Image
        borderRadius="full"
        boxSize="40px"
        src="https://100k-faces.glitch.me/random-image"
        alt={`Avatar of ${props.name}`}
      />
      <Text fontWeight="medium">{props.name}</Text>
      <Text>—</Text>
      <Text>{props.date.toLocaleDateString()}</Text>
    </HStack>
  );
};

const About = () => {
  const { colorMode, toggleColorMode } = useColorMode(false);
  return (
    <>
      <Box h={{ base: "60px", sm: "90px" }}></Box>
      <Container
        maxW={{ base: "97%", lg: "90%" }}
        id="about"
        className="about section"
        p={{ base: "2", sm: "12" }}
        textAlign="center"
      >
        <Fade bottom>
          <Heading mb={"10"} as="h1">
            About Me
          </Heading>
        </Fade>
        <Fade bottom>
          <Flex
            w={"100%"}
            m="auto"
            direction={{ base: "column", lg: "row" }}
            bg={useColorModeValue("white", "gray.800")}
            borderRadius="20px"
            border="1px"
            borderColor={useColorModeValue("gray.400", "gray.700")}
            p="20px"
            textAlign={"left"}
            boxShadow={
              colorMode === "light"
                ? "rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                : "rgba(230, 250, 255, 0.56) 0px 22px 70px 4px;"
            }
            // marginTop={{ base: "5", sm: "5" }}
            mt="60px"
            justifyContent={{ base: "center", lg: "space-between" }}
          >
            <Box marginRight="3" w={{ base: "100%", md: "100%", lg: "30%" }}>
              <Flex
                width={{ base: "60%", md: "40%", lg: "100%" }}
                justifyContent={"center"}
                textAlign={"center"}
                borderRadius={"50%"}
                m="auto"
                zIndex="2"
                
              >
                <Image
                  textAlign={"center"}
                  class="home-img"
                  // width="100%"
                  src={"about_section.gif"}
                  border="1px solid white"
                  alt="some good alt text"
                  // objectFit="cover"
                />
              </Flex>
            </Box>
            <Flex
              // border={"5px solid red"}
              w={{ base: "100%", lg: "70%" }}
              mt={{ base: "40px", lg: "0px" }}
              flexDirection="column"
              justifyContent="center"
            >
              {/* <BlogTags tags={['Engineering', 'Product']} /> */}
              <Flex
                direction={{ base: "column", md: "row" }}
                justifyContent={"space-between"}
                textAlign="center"
                marginBottom={"20px"}
              >
                <Box
                  // w="30%"
                  w={{ base: "100%", md: "30%" }}
                  mt={{ base: "30px", md: "0px" }}
                  padding={"18px"}
                  borderRadius="9px"
                  boxShadow={
                    colorMode === "light"
                      ? "rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                      : "rgba(230, 250, 255, 0.56) 0px 22px 70px 4px;"
                  }
                >
                  <Text>1200+ Hours</Text>
                  <Text>Full Stack Coding</Text>
                </Box>

                <Box
                  w={{ base: "100%", md: "30%" }}
                  mt={{ base: "30px", md: "0px" }}
                  padding={"18px"}
                  borderRadius="9px"
                  boxShadow={
                    colorMode === "light"
                      ? "rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                      : "rgba(230, 250, 255, 0.56) 0px 22px 70px 4px;"
                  }
                >
                  <Text>550+ DSA Problems</Text>
                  <Text>4+ Major Projects</Text>
                </Box>

                <Box
                  w={{ base: "100%", md: "30%" }}
                  mt={{ base: "30px", md: "0px" }}
                  padding={"18px"}
                  borderRadius="9px"
                  boxShadow={
                    colorMode === "light"
                      ? "rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                      : "rgba(230, 250, 255, 0.56) 0px 22px 70px 4px;"
                  }
                >
                  <Text>100+ Hours</Text>
                  <Text>Soft Skills</Text>
                </Box>
              </Flex>
              <Heading fontSize={"28px"} marginTop="1">
                <Link textDecoration="none" _hover={{ textDecoration: "none" }}>
                  Summary
                </Link>
                {/* <Button
                id="resume-button-2"
                colorScheme="teal"
                size="md"
              ></Button> */}
              </Heading>
              <Text
                as="p"
                marginTop="2"
                color={useColorModeValue("gray.700", "gray.200")}
                fontSize="lg"
                id="user-detail-intro"
              >
                I am a Full Stack Developer in MERN stack with good knowledge of
                Express, MongoDB, JavaScript, HTML, CSS, and other related
                technologies. I am passionate about learning new technologies
                and aim to create world-class web applications that help
                organizations achieve their ambitious goals.
              </Text>
              {/* <BlogAuthor name="John Doe" date={new Date('2021-04-06T19:01:27Z')} /> */}
            </Flex>
          </Flex>
        </Fade>
        <Divider marginTop="20" />
      </Container>
    </>
  );
};

export default About;
